// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows. The `margin: '- -Z2'` list
// pulls compensated the old hand-rolled `padding: 'Z1 A'` body (gone —
// MenuPanel pads Y, rows run full-width), and the `':hover': { '& svg': … }`
// opacity armor fought the retired KeyValueColumnFields/DropdownItem svg
// games (MenuPanelItem has none). The second list is icon-less, so it needs
// no Icon config at all — the old `Icon: null` only existed to suppress
// KeyValueColumnFields' baked-in checkmark.
const Dropdownmorelearnmenu = {
  extends: 'MenuPanel',
  gap: 'A',
  Items: {
    flow: 'y',
    gap: '0',
    childExtends: 'MenuPanelItem',
    childProps: {
      Icon: {
        order: '-1',
        margin: '- Y1 - -'
      }
    },
    childrenAs: 'props',
    children: (el) => [
      {
        text: '{{ learn.menu.onboarding | polyglot }}',
        Icon: {
          name: 'intOutline'
        },
        onClick: (ev, el) => {
          el.setWindow('explorer', 'onboarding')
          el.parent.update()
        }
      },
      {
        text: '{{ learn.examples.title | polyglot }}',
        Icon: {
          name: 'ratingFrame'
        },
        onClick: (ev, el) => {
          el.setWindow('docs', '/examples')
        }
      },
      {
        text: '{{ learn.menu.properties | polyglot }}',
        Icon: {
          name: 'ratingFrame'
        },
        onClick: (ev, el) => {
          el.setWindow('docs', '/props')
        }
      }
    ]
  },
  GeneralNav: {
    CaptionTitle: {
      margin: 'X - X2',
      // Align the caption with MenuPanelItem's Z1 label inset.
      padding: '- Z1',
      Text: {
        text: '{{ shell.app.more | polyglot }}'
      }
    },
    Items: {
      flow: 'y',
      gap: '0',
      childExtends: 'MenuPanelItem',
      childrenAs: 'props',
      children: (el) => [
        {
          text: '{{ learn.intro.symbols | polyglot }}',
          onClick: (ev, el) => {
            el.setWindow('docs', '/intro')
          }
        },
        {
          text: '{{ editor.command.docs.description | polyglot }}',
          onClick: (ev, el) => {
            el.setWindow('docs', '/developers')
          }
        },
        {
          text: '{{ learn.menu.contribution | polyglot }}',
          onClick: (ev, el) => {
            el.setWindow('docs', '/symbols-developer')
          }
        }
      ]
    }
  }
}

export { Dropdownmorelearnmenu as 'Dropdown.MoreLearnMenu' }
